import { dcpcApi } from './dcpcApi';

export const CODE_VALUE_TAG = 'codeValuesTag';

dcpcApi.enhanceEndpoints({ addTagTypes: [CODE_VALUE_TAG] });

const codeValuesApi = dcpcApi.injectEndpoints({
  endpoints: (builder) => ({
    getCodeValueById: builder.query({
      query: (id) => `code-values/${id}`,
      providesTags: [CODE_VALUE_TAG],
    }),
    createCodeValue: builder.mutation({
      query: ({ body }) => ({
        url: 'code-values',
        method: 'POST',
        body,
      }),
      invalidatesTags: [CODE_VALUE_TAG],
    }),
    updateCodeValue: builder.mutation({
      query: ({ id, body }) => ({
        url: `code-values/${id}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: [CODE_VALUE_TAG],
    }),
    deleteCodeValue: builder.mutation({
      query: (id) => ({
        url: `code-values/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: [CODE_VALUE_TAG],
    }),
  }),
});

export const {
  useGetCodeValueByIdQuery,
  useCreateCodeValueMutation,
  useUpdateCodeValueMutation,
  useDeleteCodeValueMutation,
} = codeValuesApi;
